// apps/lk/src/components/dashboard/DiscBlock.tsx
'use client';

const DISC_NAMES: Record<string, string> = {
  D: 'Доминирование',
  I: 'Влияние',
  S: 'Постоянство',
  C: 'Добросовестность',
};

const DISC_DESC: Record<string, string> = {
  D: 'Прямолинейный, решительный, ориентирован на результат',
  I: 'Общительный, вдохновляющий, эмоциональный',
  S: 'Спокойный, надёжный, командный игрок',
  C: 'Точный, аналитический, следует правилам',
};

const DISC_COLORS: Record<string, string> = {
  D: 'bg-rose-400',
  I: 'bg-amber-400',
  S: 'bg-emerald-400',
  C: 'bg-indigo-400',
};

export function DiscBlock({ data }: { data: any }) {
  if (!data?.percent) return null;
  const pct = data.percent;
  const primary = data.primaryType;
  const secondary = data.secondaryType;

  const types = (['D', 'I', 'S', 'C'] as string[]).sort((a, b) => pct[b] - pct[a]);

  return (
    <section className="mb-8">
      <h2 className="mb-4 text-lg font-bold text-slate-900">Поведенческий стиль (DISC)</h2>

      <div className="grid gap-6 lg:grid-cols-2">
        {/* Типы с барами */}
        <div className="rounded-2xl border border-slate-200 bg-white p-6">
          <h3 className="mb-4 text-sm font-semibold text-slate-700">Распределение</h3>
          <div className="space-y-4">
            {types.map(letter => (
              <div key={letter}>
                <div className="mb-1 flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <span className={`flex h-7 w-7 items-center justify-center rounded-lg text-xs font-bold text-white ${DISC_COLORS[letter]}`}>
                      {letter}
                    </span>
                    <span className="text-sm font-medium text-slate-700">{DISC_NAMES[letter]}</span>
                  </div>
                  <span className="text-sm font-bold text-slate-900">{pct[letter]}%</span>
                </div>
                <div className="h-2 overflow-hidden rounded-full bg-slate-100">
                  <div className={`h-full rounded-full ${DISC_COLORS[letter]}`} style={{ width: `${pct[letter]}%` }} />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Характеристика типа */}
        <div className="rounded-2xl border border-slate-200 bg-white p-6">
          <h3 className="mb-3 text-sm font-semibold text-slate-700">Ваш профиль</h3>
          {primary && (
            <div className="mb-3">
              <div className="flex items-center gap-2">
                <span className={`flex h-8 w-8 items-center justify-center rounded-lg text-sm font-bold text-white ${DISC_COLORS[primary]}`}>
                  {primary}
                </span>
                <span className="text-base font-bold text-slate-900">{DISC_NAMES[primary]}</span>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{DISC_DESC[primary]}</p>
            </div>
          )}
          {secondary && secondary !== primary && (
            <div className="border-t border-slate-100 pt-3">
              <p className="text-xs text-slate-400">Дополнительный стиль</p>
              <div className="mt-1 flex items-center gap-2">
                <span className={`flex h-6 w-6 items-center justify-center rounded text-xs font-bold text-white ${DISC_COLORS[secondary]}`}>
                  {secondary}
                </span>
                <span className="text-sm font-medium text-slate-700">{DISC_NAMES[secondary]}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
